"use strict";
/**
 * Copyright © 2019 - Present, VamStar Limited
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or
 * without modification, are not permitted.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CalendarDayPicker = void 0;
const react_1 = __importDefault(require("react"));
const lab_1 = require("@mui/lab");
const WithBaseCalendarDatePicker_1 = require("../WithBaseCalendarDatePicker");
/**
 * Day wise date picker
 */
exports.CalendarDayPicker = WithBaseCalendarDatePicker_1.withBaseCalendarDatePicker((props) => (react_1.default.createElement(lab_1.DatePicker, Object.assign({}, props, { openTo: "day", showToolbar: false, inputFormat: "d MMMM yyyy" }))));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQ2FsZW5kYXJEYXlQaWNrZXIuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi9zcmMvY2FsZW5kYXIvZGF0ZS1waWNrZXIvcGlja2Vycy9DYWxlbmRhckRheVBpY2tlci50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBOzs7Ozs7R0FNRzs7Ozs7O0FBRUgsa0RBQTBCO0FBQzFCLGtDQUF1RDtBQUV2RCw4RUFBMkU7QUFFM0U7O0dBRUc7QUFDVSxRQUFBLGlCQUFpQixHQUFHLHVEQUEwQixDQUFDLENBQUMsS0FBc0IsRUFBRSxFQUFFLENBQUMsQ0FDdEYsOEJBQUMsZ0JBQVUsb0JBQUssS0FBSyxJQUFFLE1BQU0sRUFBQyxLQUFLLEVBQUMsV0FBVyxFQUFFLEtBQUssRUFBRSxXQUFXLEVBQUMsYUFBYSxJQUFHLENBQ3JGLENBQUMsQ0FBQyJ9